export default "__VITE_ASSET__CHl$iTDK__"